<button class="icon-btn" stHoveredLeftMenu [menuOptions]="menuOptions" [menuTemplate]="toolsMenu">
  <em class="icon-circles-four"></em>
</button>

<ng-template #toolsMenu>
  <div class="w-full tools-menu flex flex-column">
    <div class="menu-header">
      <div class="body-large-bold">Tools</div>
    </div>
    <div class="flex flex-column gap-1 tools-menu-list flex-1">
      @for(tool of tools(); track $index){
        <a class="flex align-items-center gap-2 tools-menu-list-item" (click)="openTool(tool.publicUrl)">
          <img [src]="tool.iconImageUrl" alt="" width="24" height="24">
          <div class="label-large-bold webkit-box-one-line" [title]="tool.name">{{tool.name}}</div>
          <em class="icon-arrow-square-out ml-auto"></em>
        </a>
      }
    </div>
  </div>
</ng-template>